<div tabindex="0" id="map" class="map"></div>
<mapside
         [LegendAttrs]="legendAttrs" [activeFarm]="ilot"
         (selectedLegendItemChange)='onSelectedLegendItemChanged($event)'
         >
</mapside>
<popup [map]="map" [selectedLegenditem]="selectedLegenditem"></popup>
